var React = require('react');

function Center (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;}")),React.createElement("path",{"className":"a","d":"M334.309,212.049H313.956V191.7h-1.908v20.352H291.7v1.908h20.351V234.31h1.908V213.957h20.353Z","transform":"translate(-291.697 -191.697)","key":1})]);
}

Center.defaultProps = {"width":"42.612","height":"42.613","viewBox":"0 0 42.612 42.613"};

module.exports = Center;

Center.default = Center;
